<template>
    <UForm
        :schema="schema"
        :state="state"
        @submit="onSubmit"
        class="max-w-md mx-auto p-6 space-y-6 bg-white dark:bg-gray-800 rounded-lg shadow-md"
    >
        <h2 class="text-2xl font-semibold mb-6 text-center">{{ $t('Reset your password') }}</h2>

        <p v-if="!success"  class="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {{ $t('Enter your email address and we will send you a link to reset your password.') }}
        </p>

         <UAlert v-if="success"  variant="soft" color="success" :title="$t('Email sent')" :description="$t('If an account exists with this email, you will receive a password reset link shortly.')" class="mb-4" />

        <div  v-if="!success" class="space-y-4">
            <UFormField :label="$t('Email')" name="email">
                <UInput class="w-full" size="lg" v-model="state.email" type="email" :placeholder="$t('Enter your email')" />
            </UFormField>
        </div>

        <div  v-if="!success" class="flex justify-between">
            <UButton :loading="customerStore.pending" :disabled="customerStore.pending || success" loading-icon="i-lucide-loader" type="submit" color="primary" variant="solid" :label="$t('Send reset link')" size="lg" />
            <ULink :href="$localePath({ name: 'login' })" class="text-sm text-blue-600 hover:underline self-center">{{ $t('Back to login') }}</ULink>
        </div>
    </UForm>
</template>
<script setup lang="ts">
const { t: $t } = useI18n()

import type { FormSubmitEvent } from '@nuxt/ui'
import { z } from 'zod'

const {
    email
} = defineProps<{
    email?: string
}>()

const schema = z.object({
    email: z.string().email($t('Invalid email address'))
})

type SchemaOut = z.output<typeof schema>

const state = reactive<SchemaOut>({
    email: email || ''
})

const customerStore = useCustomerStore()
const toast = useToast()
const success = ref<boolean>(false)

const onSubmit = async ({ data } : FormSubmitEvent<SchemaOut>) => {
    try {
        await customerStore.sendPasswordResetLink(data.email);
        success.value = true
    } catch (e) {
        // Don't show error to prevent email enumeration
        console.error('Password reset failed:', e);
        success.value = true
    }
}
</script>